const cdrcsvcolumndata = [
  {
    id: "id",
    title: "Id",
  },
  {
    id: "callid",
    title: "Call ID",
  },
  {
    id: "card",
    title: "Pin Id",
  },
  {
    id: "pin",
    title: "Pin",
    default: true,
  },
  {
    id: "name",
    title: "Pin Name",
  },
  {
    id: "type",
    title: "Pin Type",
    default: true,
  },
  {
    id: "src",
    title: "From",
    default: true,
  },
  {
    id: "destination",
    title: "To",
    default: true,
  },
  {
    id: "destination_name",
    title: "Destination Name",
  },
  {
    id: "starttime",
    title: "Start Time",
    default: true,
  },
  {
    id: "stoptime",
    title: "End Time",
    default: true,
  },
  {
    id: "sessiontime",
    title: "Call Minutes",
  },
  {
    id: "billed_sessiontime",
    title: "Billed Minutes",
    default: true,
  },
  {
    id: "tariff",
    title: "Tariff",
  },
  {
    id: "blockprice",
    title: "Price per Minute",
  },
  {
    id: "blockcost",
    title: "Cost per Minute",
  },
  {
    id: "sessionprice",
    title: "Call Price",
    default: true,
  },
  {
    id: "sessioncost",
    title: "Call Cost",
  },
  {
    id: "answered",
    title: "Answered",
  },
  {
    id: "terminatecauseid",
    title: "Termination Cause",
    default: true,
  },
  {
    id: "direction",
    title: "Call Direction",
  },
  {
    id: "archived",
    title: "Archived",
  },
];
export default cdrcsvcolumndata;
